<script>
import { pick } from 'lodash-es'

export default {
    name: 'CustomerDiscountBase',
    props: {
        discount: {
            type: Object,
            required: true
        },
        percentFormatOptions: {
            type: Object,
            default: () => { 
                return {
                    locales: 'hu',
                    options: {
                        style: 'decimal',
                        minimumFractionDigits: 0, 
                        maximumFractionDigits: 2 
                    }
                }
            }
        }
    },
    computed: {
        formattedPercentage() {
            return this.display.format(Number(this.$props.discount.percentage))
        }
    },
    created() {
        this.display = new Intl.NumberFormat(this.percentFormatOptions.locales, this.percentFormatOptions.options)
    },
    render() {
        return this.$scopedSlots.default(
            pick(this, ['formattedPercentage'])
        )
    }
}
</script>